<div id="o-que-estao-falando" class="row mb-5">
  <app-selo-escola [escola]="escola" [seloId]="1" seloNome="familys"></app-selo-escola>
</div>
